import { parseCSV } from './csv';
import { normalizeManagerName } from './managerStats';

const CHAMPIONSHIPS_CSV = '/data/championships.csv';

const CHAMPIONSHIP_EDITORIAL = {
  2017: {
    headline: 'Blake. Back-to-back.',
    blurb: "Blake drafted Hatley's starting 5 and receives the 2017 championship. Robby helped complete the season following Blake's passing.",
  },
};

// Real CSV columns: Year,Champion,Team,Record,Method
// "Method" distinguishes "Regular Season Champion" (NOT a ring) from
// "Playoff Champion" / "Regular Season & Playoff Champion" (rings).
// We treat ring = playoff champion only.
//
// Normalize CSV names through the shared manager-name boundary so every
// downstream consumer (ring counts, avatars, and routes) keys against MANAGERS.

function isPlayoffChampion(method) {
  if (!method) return false;
  // Catches "Playoff Champion" and "Regular Season & Playoff Champion".
  // Excludes pure "Regular Season Champion".
  return /Playoff Champion/i.test(method);
}

export async function loadChampionships() {
  const response = await fetch(CHAMPIONSHIPS_CSV);
  if (!response.ok) throw new Error('Failed to load championships');

  const rows = parseCSV(await response.text());

  const out = [];
  for (const row of rows) {
    if (!row.Year || !row.Champion) continue;
    if (!isPlayoffChampion(row.Method)) continue; // rings only

    const year = parseInt(row.Year, 10);
    if (Number.isNaN(year)) continue;

    const editorial = CHAMPIONSHIP_EDITORIAL[year] || {};
    out.push({
      year,
      champion: normalizeManagerName(row.Champion),
      team: row.Team || null,
      record: row.Record || null,
      method: row.Method || null,
      // Fields not yet present in CSV (per spec line 210, backfill TBD):
      runner_up: null,
      final_margin: null,
      reg_season_record: null,
      points_for: null,
      headline: editorial.headline || null,
      blurb: editorial.blurb || null,
    });
  }
  out.sort((a, b) => b.year - a.year);
  return out;
}

export function ringCountsByManager(championships) {
  const counts = {};
  championships.forEach(({ champion }) => {
    const manager = normalizeManagerName(champion);
    if (!manager) return;
    counts[manager] = (counts[manager] || 0) + 1;
  });
  return counts;
}

export function ringYearsByManager(championships) {
  const years = {};
  championships.forEach(({ year, champion }) => {
    const manager = normalizeManagerName(champion);
    if (!manager) return;
    if (!years[manager]) years[manager] = [];
    years[manager].push(year);
  });
  return years;
}
